// Categories and pagination always use real WordPress links.
export function initArchive({scope}) {
 const root=scope.root.querySelector('[data-aw-archive]');if(!root||scope.editor)return;
 const win=scope.ownerDocument.defaultView,mobile=win.matchMedia('(max-width:767px)');
 const sync=()=>{const count=mobile.matches?3:6;if(Number(root.dataset.pageSize)===count)return;const url=new URL(root.dataset.baseUrl,win.location.href);url.searchParams.set('aw_count',count);if(win.location.search.includes('aw_review'))url.searchParams.set('aw_review','1');win.location.replace(url);};
 scope.on(mobile,'change',sync);sync();
}
